import { App_Url_New } from "@/shared/common/static";

import type { ResumeTarget } from "../utils/resumeJourney";

const healthGetQuoteStep = (stepIndex: number) =>
  `${App_Url_New.D2CPageUrl.insurance.healthGetQuote}?step=${stepIndex}`;

export const HEALTH_RESUME_STEP_TARGETS = {
  step_1_pre_request: {
    path: healthGetQuoteStep(1),
    stepIndex: 1,
    stepLabel: "Personal Details",
  },
  step_2_pre_request: {
    path: healthGetQuoteStep(2),
    stepIndex: 2,
    stepLabel: "Health Details",
  },
  step_3_pre_request: {
    path: healthGetQuoteStep(3),
    stepIndex: 3,
    stepLabel: "Health Habits",
  },
  step_4_pre_request: {
    path: healthGetQuoteStep(4),
    stepIndex: 4,
    stepLabel: "Quick Questions",
  },
  quote_request: {
    path: healthGetQuoteStep(5),
    stepIndex: 5,
    stepLabel: "Get Quote",
  },
  selected_quote: {
    path: healthGetQuoteStep(5),
    stepIndex: 5,
    stepLabel: "Buy Now",
  },
  step_5_post_request: {
    path: healthGetQuoteStep(6),
    stepIndex: 6,
    stepLabel: "Document Upload",
  },
  step_6_post_request: {
    path: healthGetQuoteStep(7),
    stepIndex: 7,
    stepLabel: "Additional Details",
  },
  step_7_post_request: {
    path: healthGetQuoteStep(8),
    stepIndex: 8,
    stepLabel: "Payment",
  },
  step_8_post_request: {
    path: App_Url_New.D2CPageUrl.insurance.healthPolicyResult,
    stepLabel: "Policy Issue",
  },
} satisfies Record<string, ResumeTarget>;

export const HEALTH_RESUME_STEP_FALLBACK_ORDER = [
  "step_8_post_request",
  "step_7_post_request",
  "step_6_post_request",
  "step_5_post_request",
  "selected_quote",
  "quote_request",
  "step_4_pre_request",
  "step_3_pre_request",
  "step_2_pre_request",
  "step_1_pre_request",
] as const;

export type HealthResumeStepName = keyof typeof HEALTH_RESUME_STEP_TARGETS;
